import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Clock, Users, User, ArrowRight } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './ProgramsPage.css';

const ProgramsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const pricingOptions = [
    {
      id: 1,
      title: "1-on-1 Private Session",
      price: 450,
      icon: <User size={40} />,
      description: "Personalized one-on-one training with dedicated coach attention",
      features: [
        "Full coach attention",
        "Customized workout plan",
        "Immediate feedback",
        "Flexible scheduling"
      ]
    },
    {
      id: 2,
      title: "2-on-1 Private Session",
      price: 350,
      icon: <Users size={40} />,
      priceNote: "per participant",
      description: "Train with a partner and share the experience",
      features: [
        "Bring a friend or family",
        "Shared motivation",
        "Partner drills",
        "Cost-effective training"
      ]
    },
    {
      id: 3,
      title: "3-on-1 Private Session",
      price: 300,
      icon: <Users size={40} />,
      priceNote: "per participant",
      description: "Small group training for maximum results",
      features: [
        "Small group dynamics",
        "Individual attention",
        "Team motivation",
        "Great value"
      ]
    },
    {
      id: 4,
      title: "Semi-Private Small Groups",
      price: 250,
      icon: <Users size={40} />,
      priceNote: "per person",
      description: "Train in a supportive small group environment",
      features: [
        "Community atmosphere",
        "Affordable option",
        "Group energy",
        "All fitness levels"
      ],
      featured: true
    }
  ];

  const services = [
    {
      id: 1,
      title: "Strength & Conditioning",
      description: "Build explosive power, endurance, and overall athletic performance"
    },
    {
      id: 2,
      title: "Boxing/Kickboxing Training",
      description: "Master the fundamentals and advanced techniques of boxing and kickboxing"
    },
    {
      id: 3,
      title: "Kids Classes",
      description: "Fun, safe, and engaging boxing classes designed specifically for children"
    },
    {
      id: 4,
      title: "Ladies Classes",
      description: "Empowering boxing and fitness classes in a supportive women-only environment"
    },
    {
      id: 5,
      title: "Self-Defense Training",
      description: "Learn practical self-defense techniques to stay safe and confident"
    },
    {
      id: 6,
      title: "Weight Loss & Toning",
      description: "Achieve your fitness goals with high-intensity boxing workouts"
    }
  ];

  return (
    <div className="programs-page">
      <Navbar />
      
      <div className="page-hero">
        <h1>PRICING & SERVICES</h1>
        <p>Private Studio sessions designed to help you achieve your fitness goals</p>
      </div>

      <section className="section">
        <div className="pricing-intro">
          <h2>SESSION PRICING</h2>
          <p>As a private studio, we charge per session for 45-minute to 1-hour training sessions. Choose the option that works best for you.</p>
        </div>

        <div className="pricing-grid">
          {pricingOptions.map((option) => (
            <div key={option.id} className={`pricing-card ${option.featured ? 'featured' : ''}`}>
              {option.featured && <div className="featured-badge">BEST VALUE</div>}
              
              <div className="pricing-icon">{option.icon}</div>
              
              <h3>{option.title}</h3>
              
              <div className="pricing-amount">
                <span className="price">R{option.price}</span>
                <span className="price-note">{option.priceNote || 'per session'}</span>
              </div>

              <p className="pricing-description">{option.description}</p>

              <ul className="pricing-features">
                {option.features.map((feature, index) => (
                  <li key={index}>{feature}</li>
                ))}
              </ul>

              <div className="session-duration">
                <Clock size={18} />
                <span>45 min - 1 hour</span>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center" style={{ marginTop: '3rem' }}>
          <Link to="/booking" className="btn-primary">
            Book Your Session
            <ArrowRight size={20} style={{ marginLeft: '8px' }} />
          </Link>
        </div>
      </section>

      <section className="section section-dark services-section">
        <h2 className="section-title text-center">OUR SERVICES</h2>
        <p className="section-subtitle text-center">
          Comprehensive training programs tailored to your goals
        </p>

        <div className="services-grid">
          {services.map((service) => (
            <div key={service.id} className="service-card">
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section cta-section-programs">
        <div className="cta-content-programs">
          <h2>READY TO GET STARTED?</h2>
          <p>Book your first session today and experience the Team Kent difference</p>
          <Link to="/booking" className="btn-primary btn-large">
            Schedule Your Session
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ProgramsPage;